import { createCompanyDataModel, ICompanyDataModel } from '../../data-models/company.data-model';

export const SAMPLE_COMPANY_NAMES = [
  'Northwind Robotics',
  'Harborline Health',
  'Lumenary Labs',
  'Quillstone',
  'Vela Energy',
  'Orchard Pay',
  'Tessellate AI',
  'Kestrel Bio',
  'Marlow Logistics',
  'Solstice Foods',
  'Pinegrove Security',
  'Copperleaf Data',
] as const;

/** Fictional companies for frosted previews. Negative ids: the company store never fetches those. */
export const SAMPLE_COMPANIES: ICompanyDataModel[] = SAMPLE_COMPANY_NAMES.map((name, index) =>
  createCompanyDataModel({ id: -900_001 - index, name, fye: 12 })
);
